import { createContext, useContext } from 'react';
const TabContext = createContext(undefined);
export function useTabContext() {
    const context = useContext(TabContext);
    if (context === undefined) {
        throw new Error('useTabContext was used outside of MTab');
    }
    return context;
}
export default TabContext;
//# sourceMappingURL=TabContext.js.map